var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M564.352484 386.978714H71.006413a22.378321 22.378321 0 1 1 0-44.756642h493.346071c63.074896 0 114.39478-51.319884 114.39478-114.397977S627.42738 113.426118 564.352484 113.426118a22.378321 22.378321 0 1 1 0-44.756642c87.754987 0 159.151422 71.396435 159.151422 159.154619s-71.396435 159.154619-159.151422 159.154619z",
    fill: "#4F46A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M815.916781 498.790397h-493.346071a22.378321 22.378321 0 1 1 0-44.756642h493.346071c63.078093 0 114.397977-51.319884 114.397977-114.404371 0-63.078093-51.319884-114.397977-114.397977-114.397977a22.378321 22.378321 0 1 1 0-44.756642c87.758184 0 159.154619 71.396435 159.154619 159.154619 0.003197 87.761381-71.393238 159.161013-159.154619 159.161013zM704.111492 954.051762a22.378321 22.378321 0 1 1 0-44.756642c63.078093 0 114.397977-51.319884 114.397977-114.401174 0-63.078093-51.319884-114.397977-114.397977-114.397976H210.762224a22.378321 22.378321 0 1 1 0-44.756642h493.346071c87.758184 0 159.154619 71.396435 159.154619 159.154618s-71.393238 159.157816-159.151422 159.157816z",
    fill: "#4F46A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M572.226456 313.449945H78.880385a22.378321 22.378321 0 1 1 0-44.756642h493.346071a22.378321 22.378321 0 1 1 0 44.756642z",
    fill: "#5FCEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M815.191084 588.383603h-493.346071a22.378321 22.378321 0 1 1 0-44.756642h493.346071a22.378321 22.378321 0 1 1 0 44.756642z",
    fill: "#FF4893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.2f726cc960ad1107e0aac574e6e056e6.svg";
export { ForwardRef as ReactComponent };